export const TIERS = [
  { name: "Member", threshold: 0 },
  { name: "Insider", threshold: 1000 },
  { name: "VIP", threshold: 3000 },
  { name: "Elite", threshold: 7500 },
  { name: "Icon", threshold: 15000 },
];

export function tierFor(points) {
  let current = TIERS[0];
  let next = null;
  TIERS.forEach((t, i) => {
    if (points >= t.threshold) {
      current = t;
      next = TIERS[i + 1] || null;
    }
  });
  return { tier: current.name, next_tier: next?.name || null, next_threshold: next?.threshold || null };
}
